<template>
    <div>
		<div class="d-flex align-items-center justify-content-between mg-b-25">
			<h3 class="df-title">Manage Fees</h3>
            <div class="d-flex">
				<router-link class="btn btn-sm pd-x-15 btn-white shadow-sm" :to="{ name: 'fees.upload' }">
					<i data-feather="upload" class="wd-10 mg-r-5"></i> Upload Fees
				</router-link>
				<router-link class="btn btn-sm btn-outline-default shadow-sm mg-l-5" :to="{ name: 'fees.new' }">
					<i data-feather="plus" class="wd-10 mg-r-5"></i> New Fee
				</router-link>
			</div>
		</div>
        <div class="row">
            <div class="col-12 mg-t-20 mg-sm-t-25">
                <table id="fees-table" class="table">
                    <thead>
                        <tr>
                            <th class="wd-10p"></th>
							<th class="wd-15p">Amount</th>
                            <th class="wd-10p">Currency</th>
                            <th class="wd-20p">Date</th>
                            <th class="wd-15p">External Portfolio ID</th>
                            <th class="wd-10p">Status</th>
                            <th class="wd-20p"></th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>

		<!-- <div class="modal" id="updateFees" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-sm modal-dialog-centered" role="document">
				<form class="modal-content" @submit.prevent="updateFees">
					<div class="modal-header">
						<h5 class="modal-title"></h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<p class="mg-b-0"></p>
					</div>
					<div class="modal-footer">
						<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
							<button-component :busy="form.busy" :label="label" :label-loading="'Please wait...'" :button-class="buttonClass"></button-component>
							<button type="button" data-dismiss="modal" class="btn btn-primary shadow-sm mg-sm-l-5">Cancel</button>
						</div>
					</div>
				</form>
			</div>
		</div> -->
    </div>
</template>

<script>
	export default {
		mounted() {
			this.table = $("#fees-table").DataTable({
				processing: true,
				serverSide: true,
				ajax: {
					headers: {
						Authorization: `Bearer ${localStorage.token}`
					},
					url: "/api/fees?datatable=true",
					dataFilter: data => {
						var json = JSON.parse(data);
						return JSON.stringify(json.data);
					}
				},
				responsive: true,
				deferRender: true,
				order: [[0, "asc"]],
				columnDefs: [
					{
						targets: 0,
						visible: false
					},
					{
						targets: [0, 2, 4, 5, 6, -1],
						className: "text-center"
					},
					{
						targets: [1, 3],
						className: "tx-semibold"
					},
					{
						targets: 1,
						render: (data, type, row, meta) => {
							return this.$options.filters.toCurrency(data, row[2]);
						}
					},
					{
						targets: 3,
						render: (data, type, row, meta) => {
							const date = moment(data, "YYYY-MM-DD").calendar(null, {
								sameDay: "[Today], MMM D",
								lastDay: "[Yesterday], MMM D",
								lastWeek: "[Last] dddd, MMM D",
								sameElse: "Do MMMM YYYY"
							});

							return data
								? date
								: '<span class="text-muted">N/A</span>';
						}
					},
					{
						targets: 4,
						render: (data, type, row, meta) => {
							return `<a href="/app/portfolios/${row[4]}" class="tx-black">${row[4]}</a>`;
						}
					},
					{
						targets: 5,
						render: (data, type, row, meta) => {
							return this.feeStatus(data);
						}
					},
					{
						targets: -1,
						orderable: false,
						data: "id",
						render: function(data, type, row, meta) {
							const disabled =
								row[6] === "" || row[6] === null ? "disabled" : "";

							return (
								`<a href="/app/fees/${row[0]}" class="btn btn-sm btn-white shadow-sm mr-2"><i data-feather="eye" class="wd-10 mg-r-5"></i> Details</a>` +
								`<a href="/app/transactions/${row[6]}" class="btn btn-sm btn-white shadow-sm mr-2 ${disabled}"><i data-feather="credit-card" class="wd-10 mg-r-5"></i> Transaction</a>`
							);
						}
					}
				],
				language: {
					searchPlaceholder: "Search...",
					sSearch: "",
					lengthMenu: "_MENU_",
					emptyTable: "No fees available for selected date."
				},
				initComplete: (settings, json) => {
					feather.replace();
				},
				drawCallback: settings => {
					feather.replace();
				}
			});

			$("#fees-table_filter label").prepend(
				"<input type='text' class='mr-2' data-toggle='datepicker' id='month' placeholder='Select month'>" +
					"<input type='text' class='mr-2' data-toggle='datepicker' id='year' placeholder='Select year'>"
			);
			$("#month")
				.datepicker({
					format: "mm",
					autoHide: true,
					date: moment().format("MM")
				})
				.on("pick.datepicker", e => {
					this.filterFees();
				});

			$("#year")
				.datepicker({
					format: "yyyy",
					autoHide: true,
					date: moment().format("YYYY")
				})
				.on("pick.datepicker", e => {
					this.filterFees();
				});

			// $("#updateFees").on("show.bs.modal", event => {
			// 	const fees = $(event.relatedTarget);
			// 	const type = _.startCase(fees.data("type"));
			// 	const modal = $("#updateFees");
			// 	modal.find(".modal-title").text(`${type} Fees`);
			// 	modal
			// 		.find(".modal-body p")
			// 		.text(
			// 			`Do you really want to ${fees.data(
			// 				"type"
			// 			)} this client's fees?`
			// 		);
			// 	this.label = `${type} fees`;
			// 	this.buttonClass =
			// 		fees.data("type") === "approve"
			// 			? "btn btn-success shadow-sm mg-b-5 mg-sm-b-0"
			// 			: "btn btn-danger shadow-sm mg-b-5 mg-sm-b-0";
			// 	this.fees = fees.data("fees");
			// 	this.form.status = fees.data("action");
			// });
			// $("#updateFees").on("hidden.bs.modal", e => {
			// 	this.form.status = null;
			// 	this.fees = null;
			// });
		},
		data() {
			return {
				table: null,
				label: null,
				buttonClass: null,
				fees: null,
				form: new Form({
					status: null
				})
			};
		},
		methods: {
			filterFees() {
				const month = $("#month").datepicker("getDate", true);
				const year = $("#year").datepicker("getDate", true);

				this.table.ajax
					.url(`/api/fees?datatable&month=${month}&year=${year}`)
					.load();
			}

			// updateFees() {
			// 	this.form
			// 		.patch(`/api/fees/${this.fees}`)
			// 		.then(({ data }) => {
			// 			this.table.ajax.reload();
			// 			$("#updateFees").modal("hide");
			// 		});
			// }
		}
	};
</script>
